import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.5 11.4995L14.5 11.4995C16.7091 11.4995 18.5 13.2904 18.5 15.4995L18.5 17M5.5 11.4995L10.5 6.5M5.5 11.4995L10.5005 16.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUndo;
